import { FC, memo } from 'react';

import styles from './styles.module.css';
import { Logo } from '../Logo';

export const Header: FC = memo(() => (
  <header className={styles.header}>
    <div className={styles.logoWrapper}>
      <Logo />
    </div>
  </header>
));
